// extracted by mini-css-extract-plugin
export var button = "_fl-4";
export var hasDarkBackground = "_fl-7";
export var hasLightBackground = "_fl-6";
export var iconWrapper = "_fl-0";
export var large = "_fl-2";
export var medium = "_fl-1";
export var small = "_fl-5";
export var xsmall = "_fl-3";